<template>
    <b-navbar toggleable="md" type="light" variant="light">

        <b-navbar-brand to="/">
            <img src="../assets/logo.png" class="d-inline-block align-middle" alt="XPLORA">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item to="/">Hjem</b-nav-item>
                <b-nav-item to="/kasse/">Kasse</b-nav-item>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-text class="welcome" right>{{welcomePhrase}}</b-nav-text>

                <b-nav-item-dropdown right >
                    <template slot="button-content">
                        <font-awesome-icon icon="user" />
                    </template>
                    <b-dropdown-item @click="handleLogout()"><font-awesome-icon icon="sign-out-alt" /> Logg ut</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>

        </b-collapse>
    </b-navbar>

</template>

<script>

export default {
    name: 'Nav',
    props: {
        userType: Number
    },
    methods: {
        handleLogout() {
            this.$store.clear()
            this.$router.replace({ name: "login" });
        }
    },
    computed: {
        welcomePhrase: function() {
            return "Hola " + this.$store.getUser().username;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.navbar {
    // padding-top: 0;
    // padding-bottom: 0;

    .navbar-brand img {
        width: 40px;
        height: auto;
    }

    // .nav-item:hover  {
    //     text-decoration: underline;
    // }
    //
    // .navbar-nav > li {
    //     padding-top: 1rem;
    //     padding-bottom: 1rem;
    // }
    // .navbar-nav > li .dropdown-toggle::after {
    //     display: none;
    // }
    //
    // .dropdown-menu {
    //     border-radius: 0;
    //     margin-top: 0;
    // }

    .welcome {
        margin-right: 1em;
    }
}

</style>
